/**
 * Local Storage Constants.
 * @constant
 */
export const LocalStorageConsts = {
    savedOpportunity: "savedOpportunity",
}